import React from 'react';

import { Accordion, Typography } from 'lighthouse';

import { FaqSectionProps } from './models';

import { MessageQuestion } from 'iconsax-react';

export const FaqSection = ({ items }: FaqSectionProps) => {
    if (!items.length) return null;

    return (
        <section className='scroll-mt-20'>
            <Typography variant='h6' color='blackHighEmphasis' component='h2' className='mb-3 flex items-center gap-2'>
                <MessageQuestion color='currentcolor' size={20} className='text-primary' />
                سوالات متداول
            </Typography>
            <div className='flex flex-col gap-2'>
                {items.map((item, index) => (
                    <div key={item.question}>
                        <Accordion
                            key={index}
                            typographyProps={{ variant: 'subtitle2', component: 'div' }}
                            accordionShadow='elevation1'
                            accordionSummery={item.question}
                            component='div'>
                            <Typography variant='caption' component='div' className='leading-6'>
                                {item.answer}
                            </Typography>
                        </Accordion>
                    </div>
                ))}
            </div>
        </section>
    );
};
